import React, { ReactElement } from 'react';
import LegislativnyMaterialDetailRow from '../LegislativnyMaterialBasicData/component/LegislativnyMaterialDetailRow';
import LegislativnyMaterialDetail from '../../../../../model/legislativnyMaterial/LegislativnyMaterialDetail';

interface Props {
  materialDetail: LegislativnyMaterialDetail;
}

const LegislativnyMaterialNonPublicData = ({ materialDetail }: Props): ReactElement => (
  <>
    <LegislativnyMaterialDetailRow
      header="Camunda ID procesu"
      data={materialDetail?.camundaId}
    />
    <LegislativnyMaterialDetailRow
      header="Autor procesu"
      data={materialDetail?.autorProcesu?.nazov}
    />
    <LegislativnyMaterialDetailRow
      header="Aktuálny predkladateľ"
      data={materialDetail?.aktualnyPredkladatel?.nazov}
    />
    <LegislativnyMaterialDetailRow
      header="Aktuálna predkladateľská inštitúcia"
      data={materialDetail?.aktualnaPredkladatelskaInstitucia?.uplnyNazov}
    />
    <LegislativnyMaterialDetailRow
      header="Ďalší pripomienkovatelia"
      data={materialDetail?.dalsiPripomienkovatelia}
      itemAttributeToShow="nazov"
    />
    <LegislativnyMaterialDetailRow
      header="Poradné orgány vlády"
      data={materialDetail?.poradnyOrganVladyList}
      itemAttributeToShow="nazovEmail"
    />
  </>
);

export default LegislativnyMaterialNonPublicData;
